<template>
	<div class="pc-about">
		<div class="section top">
			<div class="text">
				<div class="tit">
					기업의 <span class="en">LIFE TIME</span>을 함께하는
					<span class="logo"></span>
				</div>
				<div class="sub">
					인간과 같이 기업에게도 생애 주기가 있습니다. <br />
					기업의 시작과 끝을 WEONUS와 함께하세요.<br />
					<br />
					기업은 성장 과정에서 오피스 이전부터 운영관리까지 끊임없는 고민을 마주합니다. <br />
					세부적인 건물 관리에서부터 사옥 이전과 같은 커다란 문제 등등.. <br />
					어떻게 해결해야 할지 막막하다면, <br />
					답은 WEONUS에 있습니다. <br />
					<br />
					WEONUS는 다양한 경험을 바탕으로 한 다수의 전문가들이 <br />
					크고 작은 문제들을 함께 해결하며 <br />
					기업의 더 나은 내일을 함께 꿈꾸겠습니다.
				</div>
			</div>
		</div>
		<div class="section graph">
			<div class="text">
				<div class="tit">함께하고 있는 기업</div>
				<ul class="list">
					<li class="item">
						<label class="label en">Corporation</label>
						22
					</li>
					<li class="item">
						<label class="label">누적 투자자문</label>
						7672. 5억원
					</li>
					<li class="item">
						<label class="label">현재가치</label>
						1조 2813.8억원
					</li>
					<li class="item">
						<label class="label">블라인드 투자자문</label>
						3069억원
					</li>
					<li class="item">
						<label class="label">현재가치</label>
						5125.2억원
					</li>
				</ul>
			</div>
		</div>
		<div class="section">
			<div class="flex img-right">
				<div class="text">
					<div class="tit">
						성공적인<br />
						실물자산 투자를 위한<br />
						<strong>단 하나의 솔루션</strong>
					</div>
					<div class="sub">
						WEONUS는 매입·매각 토탈 솔루션을 제공해 효율적인 자산운용을 도와드립니다.<br />
						DB 및 매입 프로세스 제공, MD 재구성을 통한 자산관리, 최종 재매각까지 복잡하고 어려운 매입·매각 계획을 보다
						세밀하게 컨설팅 해드립니다.<br />
						뿐만 아니라 지속적인 경제 및 부동산의 흐름과 주요 뉴스레터 제공을 통해 파트너사의 자산 증대를 서포트합니다.
					</div>
				</div>
				<div class="img">
					<img src="../assets/images/pc/about_img_1.png" alt="" />
				</div>
			</div>
			<div class="flex">
				<div class="img">
					<img src="../assets/images/pc/about_img_2.png" alt="" />
				</div>
				<div class="text">
					<div class="tit">
						더 나은 투자를 위한<br />
						<strong>투자전략 서포터</strong>
					</div>
					<div class="sub">
						WEONUS는 투자를 통해 더 나은 미래를 개척해 나갈 수 있다고 믿습니다.<br />
						투자의 본질인 리스크 대처와 기대수익률에 집중할 수 있는 환경을 만들기 위해 실물자산 투자자들의 파트너로서
						신뢰할 수 있는 DB와 보다 편리한 정보제공 서비스 체계를 만들어 나가고 있습니다.
					</div>
				</div>
			</div>
			<div class="flex img-right">
				<div class="text">
					<div class="tit">
						기업의 <span class="en">LIFE TIME</span>을 함께하는 조력자
						<strong class="en">WEONUS</strong>
					</div>
					<div class="sub">
						기업의 탄생과 지속적인 성장을 거듭하는 과정 속에서 기업은 예측할 수 없었던 ‘공간’이라는 과제에 끊임없이
						직면하게 됩니다.<br />
						그 과정속에서 보다 합리적이고 경쟁력 있는 결과로 도출해 내는 것.<br />
						WEONUS와 함께 기업의 성장을 이루어 가야하는 이유이자 해답입니다.
					</div>
				</div>
				<div class="img">
					<img src="../assets/images/pc/about_img_3.png" alt="" />
				</div>
			</div>
			<div class="flex">
				<div class="img">
					<img src="../assets/images/pc/about_img_4.png" alt="" />
				</div>
				<div class="text">
					<div class="tit">
						<strong class="en">WEONUS</strong>가<br />
						존재하는 이유
					</div>
					<div class="sub">
						WEONUS는 계속해서 변화하는 오피스 문화와 실물자산 시장의 효율적이지 못한 근본적 문제에 해답을 제시하기 위해
						존재하는 프롭테크 기업입니다.<br />
						<br />
						직접 수집한 +80,000건 이상의 DB를 가공해, 보다 양질의 정보를 제공하고 불필요한 리소스를 절감하여 효율적이고
						합리적인 선택을 하며 성공적인 투자를 위해 함께 합니다.
					</div>
				</div>
			</div>
		</div>
		<div class="section">
			<div class="text-left">
				<div class="tit">
					독립된 공간,<br />
					사옥마련의 시작
				</div>
				<div class="sub">
					기업의 성장과정 속에 독립된 공간이 필수적인 시기가 있습니다.<br />
					기업의 성장과 자산증대를 함께 고민하고 해답을 제시합니다.<br />
					독립된 공간, 사옥마련의 시작을 WEONUS 전문가와 함께하세요.
				</div>
			</div>
			<div class="img-flex">
				<img src="../assets/images/pc/about_img_5.png" alt="" />
				<img src="../assets/images/pc/about_img_5_2.png" alt="" />
			</div>
		</div>
		<div class="section slide">
			<div class="slide-wrap">
				<div class="tit en">MISSION</div>
				<swiper :modules="modules" :slides-per-view="1" :autoplay="{ delay: 4000 }" :loop="true">
					<swiper-slide class="swiper-slide">
						<div class="icon-wrap">
							<span class="dot-line"></span>
							<div class="circle">
								<div class="icon icon-1"></div>
							</div>
						</div>
						<div class="text">
							건물의 기반이 될 토지의 잠재된 가치를 파악하고<br />
							더 가치 있는 공간으로 이끌어 내는 것.
						</div>
					</swiper-slide>
					<swiper-slide class="swiper-slide">
						<div class="icon-wrap">
							<span class="dot-line"></span>
							<div class="circle">
								<div class="icon icon-2"></div>
							</div>
						</div>
						<div class="text">
							기업성장의 기반이 될 공간을 선별하고,<br />
							모든 공간에 잠재된 최상의 상태를 이끌어내는 것.
						</div>
					</swiper-slide>
					<swiper-slide class="swiper-slide">
						<div class="icon-wrap">
							<span class="dot-line"></span>
							<div class="circle">
								<div class="icon icon-3"></div>
							</div>
						</div>
						<div class="text">
							기업자본의 기반이 될 자산을 디자인하고,<br />
							모든 공간의 잠재된 최상의 가치를 파악해내는 것.
						</div>
					</swiper-slide>
					<swiper-slide class="swiper-slide">
						<div class="icon-wrap">
							<span class="dot-line"></span>
							<div class="circle">
								<div class="icon icon-4"></div>
							</div>
						</div>
						<div class="text">
							독립공간의 시작이 될 사옥을 선별하고,<br />
							모든 과정에 기업의 TF팀 전문가로 함께 해내는 것.
						</div>
					</swiper-slide>
					<swiper-slide class="swiper-slide">
						<div class="icon-wrap">
							<span class="dot-line"></span>
							<div class="circle">
								<div class="icon icon-5"></div>
							</div>
						</div>
						<div class="text">
							업무환경의 기반이 될 공간을 디자인하고,<br />
							구상된 공간을 현실로 완벽히 구현 해내는 것
						</div>
					</swiper-slide>
				</swiper>
				<div class="text"><strong class="en">WEONUS</strong>가 가장 잘하는 일입니다</div>
			</div>
		</div>
		<div class="section bottom">
			<div class="tit">
				보다 효율적인 자산관리를 위한<br />
				<strong>자산증대 계획 수립 방안</strong>을 마련합니다.
			</div>
			<div class="sub">부동산 매입은 물론, 다양한 연계시스템을 활용해 고객의 부동산 자산의 가치 상승을 책임집니다.</div>
			<div class="state">
				<div class="box">
					<div class="tit">실물자산 매입</div>
					부동산 시장 분석<br />
					투자 사업성 분석<br />
					금융기관 연계<br />
					법률 및 세무 자문
				</div>
				<div class="box">
					<div class="tit">실물자산 가치상승</div>
					신축 및 대수선<br />
					수익성 관리분석<br />
					공실관리<br />
					월수입관리
				</div>
				<div class="box">
					<div class="tit">실물자산 매각</div>
					경제적 검토<br />
					부동산 시장 실사<br />
					매각 타당성 검토<br />
					법률 및 세무 자문
				</div>
				<div class="label-wrap">
					<span class="label">매각 이후 매입 전략</span>
				</div>
			</div>
		</div>
	</div>
	<div class="footer">
		<div class="footer-wrap">
			<div class="footer-logo"></div>
			<div class="footer-info">
				<div class="line">
					<span>대표 : 서치원</span>
					<span>사업자 등록번호 : 395-87-02794</span>
					<span>주소 : 서울특별시 강남구 도산대로26길 20, 1층(논현동, NEWTURN빌딩)</span>
				</div>
				<div class="line">
					<span>대표번호 : 02-6956-2791</span>
					<span>팩스 : 070-4693-5728</span>
				</div>
			</div>
			<div class="footer-copy">
				개인정보처리방침<br />
				Copyrightⓒ2023 WEONUS All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
	name: 'PC_Main',
	components: { Swiper, SwiperSlide },
	computed: {},
	data() {
		return {
			swiper: null,
			modules: [Autoplay],
		};
	},
	created() {},
	methods: {},
};
</script>
